module.exports = __webpack_public_path__ + "img/waerme-img1-3_2v2.5bb31cb5.png";